import {
  number,
  largerEq,
  smaller,
  sum,
  multiply,
  round,
  floor,
  subtract,
  larger,
  max,
} from "mathjs";
import moment from "moment";
import Vue from "vue";
import { review_score_values, get_beds } from "@liveeps/resources";
import { get_to_points, get_config, get_availability } from "@utilities/commons";
import { is_vivamod } from "@liveeps/utilities/mixins";
const decimals = 2;

export function markup(price) {
  let mu = JSON.parse(atob(Vue.prototype.$config.mu)),
    markups = mu["DEFAULT"] || [],
    pricerange_markup = 0,
    customer_markup = number(mu.ADD.p || 0.1),
    mu_percent = customer_markup,
    mu_display_percent = mu.DISPLAY ? mu.DISPLAY.p : 0;

  markups.forEach((m) => {
    if (largerEq(number(price), number(m.min))) {
      pricerange_markup = number(m.p);
    } else {
      return;
    }
  });

  if (Vue.prototype.$config.forced_mu) {
    // caso CONFIRM -> markup forzato da confirm()
    mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu));
  } else {
    mu_percent = round(sum(pricerange_markup, customer_markup), 3); // percentuale markup 3 decimali
  }

  let markup = round(multiply(price, mu_percent), decimals);
  let live_price = round(sum(price, markup), decimals);

  let display_markup = round(multiply(price, mu_display_percent), decimals);
  let display_price = round(sum(price, display_markup), decimals);

  if (smaller(live_price, price)) live_price = price;

  /*window.console.table({
    price: price,
    mu_percent: mu_percent,
    markup: markup,
    live_price: live_price,
    display_price: display_price,
  })*/

  return {
    markup: String(markup), // ammontare del markup
    live_price: String(live_price), // markup su prezzo netto
    display_price: String(display_price), // markup "finto" su prezzo commissionabile
  };
}

export function reverse_markup(live_price) {
  let mu = JSON.parse(atob(Vue.prototype.$config.mu));
  let markups = mu["DEFAULT"] || [];
  let customer_markup = number(mu.ADD.p || 0.1);
  let mu_percent = customer_markup;
  let pricerange_markup = 0;

  if (Vue.prototype.$config.forced_mu) {
    mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu));

    let price = number(live_price) / (1 + mu_percent);
    price = round(price, decimals);

    return {
      price: String(price),
      mu_percent: mu_percent,
      customer_markup: customer_markup,
    };
  }

  let sorted_markups = [...markups].sort(
    (a, b) => number(b.min) - number(a.min)
  );

  for (let i = 0; i < sorted_markups.length; i++) {
    let test_pricerange_markup = number(sorted_markups[i].p);
    let test_mu_percent = round(
      sum(test_pricerange_markup, customer_markup),
      3
    );

    let test_price = number(live_price) / (1 + test_mu_percent);
    test_price = round(test_price, decimals);

    if (largerEq(number(test_price), number(sorted_markups[i].min))) {
      let markup_test = round(multiply(test_price, test_mu_percent), decimals);
      let live_price_test = round(sum(test_price, markup_test), decimals);

      if (smaller(live_price_test, test_price)) {
        live_price_test = test_price;
      }

      if (number(live_price_test) === number(live_price)) {
        return {
          price: String(test_price),
          mu_percent: test_mu_percent,
          pricerange_markup: test_pricerange_markup,
          customer_markup: customer_markup,
        };
      }
    }
  }

  mu_percent = customer_markup;
  let price = number(live_price) / (1 + mu_percent);
  price = round(price, decimals);

  return {
    price: String(price),
    mu_percent: mu_percent,
    pricerange_markup: pricerange_markup,
    customer_markup: customer_markup,
  };
}

const priceMarkUp = (
  price,
  markups,
  customer_markup,
  mu_percent,
  pricerange_markup
) => {
  if (!price) {
    return 0;
  }

  let priceRangeMarkup = pricerange_markup;
  if (!pricerange_markup) {
    priceRangeMarkup = (markups || []).reduce(
      (res, m) =>
        largerEq(number(price), number(m.min)) ? number(m.p) : number(res),
      0
    );
  }
  let percent = mu_percent || round(sum(priceRangeMarkup, customer_markup), 3); // percentuale markup 3 decimali
  if (!mu_percent && Vue.prototype.$config.forced_mu) {
    // caso CONFIRM -> markup forzato da confirm()
    try {
      percent = JSON.parse(atob(Vue.prototype.$config.forced_mu));
    } catch (e) {
      window.console.log("priceMarkUp error on mu_percent");
      window.console.log(e);
    }
  }
  const markup = round(multiply(price, percent), decimals);
  return max(round(sum(price, markup), decimals), price);
};

export function markupPricing(pricing) {
  const price = pricing.total;

  let mu = {};
  try {
    mu = JSON.parse(atob(Vue.prototype.$config.mu));
  } catch (e) {
    window.console.log("markupPricing error on mu");
    window.console.log(e);
    // Return nothing to avoid displaying the wrong price
    return {};
  }
  const markups = mu["DEFAULT"] || [];
  const customer_markup = number(mu.ADD.p || 0.1);
  const { p: mu_display_percent = 0 } = mu.DISPLAY || {};

  const pricerange_markup = markups.reduce(
    (res, m) => (largerEq(number(price), number(m.min)) ? number(m.p) : res),
    0
  );

  let mu_percent = round(sum(pricerange_markup, customer_markup), 3); // percentuale markup 3 decimali
  if (Vue.prototype.$config.forced_mu) {
    // caso CONFIRM -> markup forzato da confirm()
    try {
      mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu));
    } catch (e) {
      window.console.log("markupPricing error on mu_percent");
      window.console.log(e);
      // Return nothing to avoid displaying the wrong price
      return {};
    }
  }

  const markup = round(multiply(price, mu_percent), decimals);
  const live_price = priceMarkUp(
    price,
    markups,
    customer_markup,
    mu_percent,
    pricerange_markup
  );
  const markedUpTotalBeforeDiscount = priceMarkUp(
    pricing.total_before_discount,
    markups,
    customer_markup
  );

  const display_markup = round(multiply(price, mu_display_percent), decimals);
  const display_price = round(sum(price, display_markup), decimals);

  // max does this -> if (smaller(live_price, price)) live_price = price

  const strikeThroughConfig = mu.STRIKETROUGH || {};
  let strikeThrough = 0;
  let markupOnStrikeThroughPercent = pricerange_markup;
  let markupOnStrikeThrough = 0;

  switch (strikeThroughConfig.mode || "none") {
    case "total":
      // strikethrough calcolato sul total
      // markup fascia prezzo + percentuale strike + eventuale abs
      markupOnStrikeThroughPercent = sum(
        markupOnStrikeThroughPercent,
        number(strikeThroughConfig.percent || "0")
      );
      markupOnStrikeThrough = round(
        multiply(price, markupOnStrikeThroughPercent),
        decimals
      );

      if (larger(number(strikeThroughConfig.abs || "0"), 0)) {
        markupOnStrikeThrough = round(
          sum(markupOnStrikeThrough, number(strikeThroughConfig.abs || "0")),
          decimals
        );
      }

      strikeThrough = round(sum(price, markupOnStrikeThrough), decimals);

      break;

    default:
      break;
  }

  if (strikeThroughConfig.debug || false) {
    window.console.table({
      price: price,
      pricerange_markup: pricerange_markup,
      customer_markup: customer_markup,
      mu_percent: mu_percent,
      markup: markup,
      live_price: live_price,
      display_price: display_price,

      strikePercent: number(strikeThroughConfig.percent || "0"),
      strikeAbs: number(strikeThroughConfig.abs || "0"),
      markupOnStrikeThroughPercent: markupOnStrikeThroughPercent,
      markupOnStrikeThrough: markupOnStrikeThrough,
      strikeThrough: strikeThrough,
    });
  }

  return {
    markup: String(markup), // ammontare del markup
    live_price: String(live_price), // markup su prezzo netto
    display_price: String(display_price), // markup "finto" su prezzo commissionabile
    // Add before discount price
    ...(larger(markedUpTotalBeforeDiscount, 0)
      ? { markedUpTotalBeforeDiscount: String(markedUpTotalBeforeDiscount) }
      : {}),
    // Add strikeThrough if present
    ...(larger(strikeThrough, 0)
      ? { strikeThrough: String(strikeThrough) }
      : {}),
  };
}

export function round_up(price) {
  return round(price, decimals);
}

/**
 * Calcola punti ed eventuale integrazione per un dato prezzo.
 * Logica estratta da rate-amount.vue per poterla riusare nei marker della mappa.
 *
 * @param {number} live_price - prezzo con markup
 * @param {object} availability - risultato di get_availability() { total, points? }
 * @returns {object|null} - null se loyalty non attivo, altrimenti { points, integration, live_price, icon_url, label }
 */
export function compute_amount_points(live_price, availability) {
  const points_data = get_to_points(live_price)
  if (!points_data || !points_data.total) return null

  const result = {
    points: points_data.total,
    integration: null,
    live_price: live_price,
    icon_url: points_data.iconUrl || 'assets/images/common/statics/fallback_loyalty.png',
    label: points_data.label || 'punti fedeltà',
  }

  if (!availability || !availability.points) return result

  const is_integration = smaller(availability.points.total, points_data.total)
  if (is_integration) {
    return {
      ...result,
      points: availability.points.total,
      integration: round(subtract(live_price, availability.total), 2),
    }
  }

  return result
}

const MONTHS_VERBOSE = {
  "01": "gennaio",
  "02": "febbraio",
  "03": "marzo",
  "04": "aprile",
  "05": "maggio",
  "06": "giugno",
  "07": "luglio",
  "08": "agosto",
  "09": "settembre",
  10: "ottobre",
  11: "novembre",
  12: "dicembre",
};

const shortMonth = (month) => (MONTHS_VERBOSE[month] || "").slice(0, 3);

export const get_suggested_booking_dates = (constraints = {}) => {
  let checkin = moment().add(10, "day");
  if (
    constraints.date_start &&
    moment(constraints.date_start).diff(checkin, "days") > 0
  ) {
    checkin = moment(constraints.date_start);
  }

  let checkout = moment(checkin).add(1, "days");
  if (
    constraints.date_end &&
    moment(constraints.date_end).diff(checkout, "days") < 0
  ) {
    checkout = moment(constraints.date_end);
  }

  return {
    checkin,
    checkout,
  };
};

export const format_booking_dates_range = (
  constraints = {},
  verbose = false
) => {
  const { date_start, date_end } = constraints;
  try {
    const isMonthDifferent = !moment(date_start).isSame(date_end, "month");

    if (verbose) {
      const isYearDifferent = !moment(date_start).isSame(date_end, "year");
      return `con IN ${moment(date_start).format("DD")}  ${shortMonth(
        moment(date_start).format("MM")
      )}${
        isYearDifferent ? ` ${moment(date_start).format("YYYY")}` : ""
      } e OUT ${moment(date_end).format("DD")} ${shortMonth(
        moment(date_end).format("MM")
      )} ${moment(date_end).format("YYYY")}`;
    }

    return `${moment(date_start).format("DD")}${
      isMonthDifferent ? ` ${shortMonth(moment(date_start).format("MM"))}` : ""
    } - ${moment(date_end).format("DD")} ${shortMonth(
      moment(date_end).format("MM")
    )}`;
  } catch (e) {
    return `${moment(date_start).format("DD-MM")} - ${moment(date_end).format(
      "DD-MM"
    )}`;
  }
};

export function format_date_with_month(time) {
  return moment(time, ["YYYY-MM-DD", "DD-MM-YYYY"])
    .locale("it")
    .format("DD MMMM YYYY");
}

export function map_markers(items, availability, sass) {
  let markers = [];
  if (!items) return [];
  items.forEach((item) => {
    let color = "#999999",
      z_index = 1,
      copy = "";

    if (!get_availability(number(item.price)).show_credit_alert) {
      color = sass("primary");
      z_index = 10;
    } else {
      copy =
        '<div class="copy">\
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g fill="var(--color)" id="_01_align_center" data-name="01 align center"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z" /><rect x="11" y="5" width="2" height="10" /><rect x="11" y="17" width="2" height="2" /></g></svg>\
          Credito non sufficiente!</div>';
    }

    let stars = "",
      stars_value = number(item.stars);
    if (stars_value > 0) {
      stars += '<div class="stars">';
      for (let i = 0; i < stars_value; i++) {
        stars +=
          '<svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="star fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-star-fill b-icon bi text-secondary"><g><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></g></svg>';
      }
      stars += "</div>";
    }

    let review_score_value = number(item.salabamScore),
      review_score = "",
      review_desc = "";
    if (review_score_value) {
      let review_score_desc = review_score_values.filter((s) => {
        return s.value >= floor(review_score_value);
      });
      if (review_score_desc.length > 0)
        review_desc = review_score_desc.reverse()[0].short_label + "<br>";
      review_score += `<div class="score">${review_desc} ${review_score_value}/10</div>`;
    }

    markers.push({
      color: color,
      name: item.name,
      content: `<div class="info-window">
              <div class="info-window__image">
                <img src="${item.imageUrl}">
              </div>
              <div class="info-window__text">
                <div class="top">
                  <div class="left">
                    <div class="name">${item.name}</div>
                    <div class="address">${item.full_address}</div>
                  </div>
                  <div class="right">
                    <div class="price">${item.price}€</div>
                  </div>
                </div>
                <div class="ratings">${stars}${review_score}</div>
                ${copy}
              </div>
              <div class="info-window__button"><button class="btn btn-primary">Vai alla struttura</button></div>
            </div>`,
      position: {
        lat: number(item.location.latitude),
        lng: number(item.location.longitude),
      },
      icon: {
        url:
          "data:image/svg+xml;base64," +
          window.btoa(
            '<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<g filter="url(#filter0_d_1016_36)">' +
            '<rect x="4" y="2" width="20" height="20" rx="10" fill="' + color + '"/>' +
            '<rect x="5" y="3" width="18" height="18" rx="9" stroke="white" stroke-width="2"/>' +
            '</g>' +
            '<g filter="url(#filter1_d_1016_36)">' +
            '<path d="M14.5 26L11.4689 20.75L17.5311 20.75L14.5 26Z" fill="white"/>' +
            '</g>' +
            '<defs>' +
            '<filter id="filter0_d_1016_36" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
            '<feOffset dy="2"/>' +
            '<feGaussianBlur stdDeviation="2"/>' +
            '<feComposite in2="hardAlpha" operator="out"/>' +
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
            '</filter>' +
            '<filter id="filter1_d_1016_36" x="7.46892" y="18.75" width="14.0622" height="13.25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
            '<feOffset dy="2"/>' +
            '<feGaussianBlur stdDeviation="2"/>' +
            '<feComposite in2="hardAlpha" operator="out"/>' +
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
            '</filter>' +
            '</defs>' +
            '</svg>'
          ),
      },
      item: item,
      z_index: z_index,
    });
  });
  return markers;
}

export function map_markers_v3(items, availability, sass) {
  let markers = [];
  if (!items) return [];

  const availability_obj = {
    total: availability,
    points: get_to_points(availability),
  }

  items.forEach((item) => {
    const pricing = markupPricing(item.room.rate.pricing);

    item.before_price =
      pricing.strikeThrough || pricing.markedUpTotalBeforeDiscount;

    const amount_points = compute_amount_points(
      number(item.live_price || 0),
      availability_obj
    )

    let color = "#999999",
      z_index = 1,
      copy = "";

    if (amount_points && is_vivamod()) {
      const welfare = get_config('integration.welfare', false)
      const needs_integration = amount_points.integration !== null
      if (!needs_integration || !welfare) {
        color = get_config('guiSettings.customizations.colors.primary', sass("primary"));
        z_index = 10;
      }
    } else if (!get_availability(number(item.live_price || 0)).show_credit_alert) {
      color = sass("primary");
      z_index = 10;
    } else {
      copy =
        '<div class="copy">\
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g fill="var(--color)" id="_01_align_center" data-name="01 align center"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z" /><rect x="11" y="5" width="2" height="10" /><rect x="11" y="17" width="2" height="2" /></g></svg>\
          Credito non sufficiente!</div>';
    }

    let stars = '<div class="stars">';
    const accommodations_details = item.accommodations_details || {};
    if (accommodations_details.stars) {
      let stars_value = number(accommodations_details.stars);
      if (stars_value > 0) {
        for (let i = 0; i < stars_value; i++) {
          stars +=
            '<svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="star fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-star-fill b-icon bi text-secondary"><g><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></g></svg>';
        }
        stars += "</div>";
      }
    } else stars += "-</div>";

    let review_score = "",
      review_desc = "";
    if (accommodations_details.salabam_score) {
      const review_score_value = number(accommodations_details.salabam_score);
      let review_score_desc = review_score_values.filter((s) => {
        return s.value >= floor(review_score_value);
      });
      if (review_score_desc.length > 0)
        review_desc = review_score_desc.reverse()[0].short_label + "<br>";
      review_score += `<div class="score">${review_desc} ${review_score_value}/10</div>`;
    }

    const price_html = amount_points
      ? `<div class="price">
          <div><img src="${amount_points.icon_url}" style="width:16px;height:16px;vertical-align:middle;margin-right:4px" />${amount_points.points}</div>
          ${amount_points.integration !== null ? '<div style="font-size:12px">+ € ' + amount_points.integration + '</div>' : ''}
        </div>`
      : `<div class="price">
          ${item.before_price ? '<div class="striked">' + item.before_price + '€</div>' : ''}
          <div>${item.live_price}€</div>
        </div>`

    markers.push({
      color: color,
      name: accommodations_details.name,
      content: `<div class="info-window">
              <div class="info-window__image">
                <img src="${accommodations_details.image_url}">
              </div>
              <div class="info-window__text">
                <div class="top">
                  <div class="left">
                    <div class="name">${accommodations_details.name}</div>
                    <div class="address">${accommodations_details.address}</div>
                  </div>
                  <div class="right">
                    ${price_html}
                  </div>
                </div>
                <div class="ratings">${stars}${review_score}</div>
                ${copy}
              </div>
              <div class="info-window__button"><button class="btn btn-primary">Vai alla struttura</button></div>
            </div>`,
      position: {
        lat: number(item.location.coordinates.latitude),
        lng: number(item.location.coordinates.longitude),
      },
      icon: {
        url:
          "data:image/svg+xml;base64," +
          window.btoa(
            '<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<g filter="url(#filter0_d_1016_36)">' +
            '<rect x="4" y="2" width="20" height="20" rx="10" fill="' + color + '"/>' +
            '<rect x="5" y="3" width="18" height="18" rx="9" stroke="white" stroke-width="2"/>' +
            '</g>' +
            '<g filter="url(#filter1_d_1016_36)">' +
            '<path d="M14.5 26L11.4689 20.75L17.5311 20.75L14.5 26Z" fill="white"/>' +
            '</g>' +
            '<defs>' +
            '<filter id="filter0_d_1016_36" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
            '<feOffset dy="2"/>' +
            '<feGaussianBlur stdDeviation="2"/>' +
            '<feComposite in2="hardAlpha" operator="out"/>' +
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
            '</filter>' +
            '<filter id="filter1_d_1016_36" x="7.46892" y="18.75" width="14.0622" height="13.25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
            '<feOffset dy="2"/>' +
            '<feGaussianBlur stdDeviation="2"/>' +
            '<feComposite in2="hardAlpha" operator="out"/>' +
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
            '</filter>' +
            '</defs>' +
            '</svg>'
          ),
      },
      price_label: amount_points ? null : "€ " + floor(item.live_price || 0),
      item: item,
      z_index: z_index,
    });
  });
  return markers;
}

export function format_beds(bed_options) {
  let beds = [];

  bed_options.forEach((bed_option) => {
    bed_option.bed_configurations.forEach((bed_conf) => {
      const arr_configuration = bed_conf.configuration.map((conf) =>
        get_beds(conf.bed_type, conf.number_of_beds)
      );
      beds.push(arr_configuration);
    });
  });

  return (beds = beds.map((option) => option.join(" e ")).join(" oppure "));
}

export function get_live_price_no_tax(
  pricing,
  book_price = null,
  extra_charges = null
) {
  /*
  window.console.log('pp', pricing)
  if (!pricing) return 0
  const charges = extra_charges !== null ? extra_charges : pricing.extra_charges
  if (!charges) return round_up(markup(pricing.total))
  const tax_22 = charges.included.find(tax => tax.charge === 22),
    base_price = book_price !== null ? book_price : pricing.book,
    tax_excluded_price = subtract(number(base_price), tax_22 ? tax_22.total_amount : 0)

  return round_up(markup(tax_excluded_price).live_price) // live_price senza tasse di soggiorno
  */
  book_price, extra_charges, subtract;
  return markup(pricing);
}

// Stuttura dati icona + label
export function build_data_items(map, data) {
  if (!data) return []
  const safe_map = Array.isArray(map) ? map : []
  return Object.keys(data)
    .filter((key) => data[key])
    .map((key) => {
      const item = safe_map.find((entry) => entry.key === key) || {};
      return {
        key: key,
        icon: item.icon || "check_circle",
        name: item.name || key,
        data: data[key],
      };
    });
}

// Ritorna numero notti + label
export function get_total_nights(from_time, to_time) {
  const p_moment = (time) => {
    return moment(time, "YYYY-MM-DD");
  };
  const from = p_moment(from_time),
    to = p_moment(to_time),
    total = to.diff(from, "days");

  return `${total} ${total === 1 ? "notte" : "notti"}`;
}

// Ritorna labeling occupancy (es. 2 adulti e 1 bambino)
export function get_label_occupancy(occupancy) {
  const { adults, children } = occupancy.reduce(
    (total, item) => {
      total.adults += item.adults;
      total.children += item.children.length;
      return total;
    },
    { adults: 0, children: 0 }
  );

  const adults_label = adults === 1 ? "adulto" : "adulti",
    children_label = children === 1 ? "bambino" : "bambini";

  return `${adults} ${adults_label} ${
    children > 0 ? "e " + children + " " + children_label : ""
  }`;
}
